import { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'
import { actievePromo, haalPromoOntvangsten, promoVoorKaart } from '../lib/promoties'

const MAANDEN = ['jan','feb','mrt','apr','mei','jun','jul','aug','sep','okt','nov','dec']

export default function StempelkaartTab({ member }) {
  const [bezoeken, setBezoeken] = useState([])
  const [loading, setLoading] = useState(true)
  const [faseInfo, setFaseInfo] = useState({ fase: member.fase ?? '1' })
  const [promoOntvangsten, setPromoOntvangsten] = useState([])

  useEffect(() => {
    laadBezoeken()
    laadFase()
    laadPromo()

    // Realtime updates
    const channel = supabase
      .channel(`fase:${member.member_id}`)
      .on('postgres_changes', {
        event: '*', schema: 'public', table: 'bezoeken',
        filter: `member_id=eq.${member.member_id}`,
      }, () => { laadBezoeken(); laadPromo() })
      .on('postgres_changes', {
        event: 'UPDATE', schema: 'public', table: 'members',
        filter: `member_id=eq.${member.member_id}`,
      }, () => laadFase())
      .subscribe()

    return () => channel.unsubscribe()
  }, [member.member_id])

  async function laadBezoeken() {
    const { data } = await supabase
      .from('bezoeken')
      .select('*')
      .eq('member_id', member.member_id)
      .order('bezocht_op', { ascending: true })
    setBezoeken(data ?? [])
    setLoading(false)
  }

  async function laadFase() {
    const { data } = await supabase
      .from('members')
      .select('fase')
      .eq('member_id', member.member_id)
      .single()
    if (data) setFaseInfo(data)
  }

  async function laadPromo() {
    try {
      setPromoOntvangsten(await haalPromoOntvangsten(member.member_id))
    } catch {
      setPromoOntvangsten([])
    }
  }

  const maximum = 20
  const fase = faseInfo.fase ?? '1'
  const faseLabel = fase === 'aangepast' ? '15+' : `Fase ${fase}`
  const faseBezoeken = bezoeken.filter(b => (b.fase ?? '1') === fase)
  const bezoekInFase = faseBezoeken.length
  const resterend = maximum - bezoekInFase
  const voltooid = bezoekInFase >= maximum
  const vakjes = Array.from({ length: maximum }, (_, i) => faseBezoeken[i] ?? null)
  const lopendePromo = actievePromo()
  const kaartPromo = voltooid ? promoVoorKaart(promoOntvangsten, fase) : null
  const magPromoVakje = !!kaartPromo

  return (
    <div>
      <div className="card">
        <p style={{ fontFamily: 'Montserrat', fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', color: 'var(--muted)', marginBottom: 6 }}>
          Jouw fasekaart — {faseLabel}
        </p>
        <p style={{ fontFamily: 'Montserrat', fontSize: 20, fontWeight: 800, color: voltooid ? 'var(--orange)' : 'var(--text)', marginBottom: 4 }}>
          {voltooid ? `${faseLabel} voltooid! 🎉` : `Nog ${resterend} bezoek${resterend !== 1 ? 'en' : ''}`}
        </p>
        <p style={{ fontSize: 12, color: 'var(--muted)', marginBottom: 16 }}>
          {bezoekInFase} van {maximum} bezoeken
        </p>

        {/* Voortgangsbalk */}
        <div style={{ background: 'var(--border)', borderRadius: 8, height: 8, marginBottom: 20, overflow: 'hidden' }}>
          <div style={{
            background: voltooid ? 'var(--orange)' : 'var(--green)',
            height: '100%',
            width: `${voltooid ? 100 : (bezoekInFase / maximum) * 100}%`,
            borderRadius: 8,
            transition: 'width 0.4s ease'
          }} />
        </div>

        {/* Fasekaart raster 4x5 */}
        {loading ? <div className="spinner" /> : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 8 }}>
            {vakjes.map((bezoek, i) => {
              const isPromoVakje = i === maximum - 1 && !!bezoek && magPromoVakje
              return (
              <div key={i} style={{
                aspectRatio: '1',
                borderRadius: 10,
                background: isPromoVakje ? '#ffffff' : (bezoek ? 'var(--green)' : 'var(--bg)'),
                border: `2px solid ${isPromoVakje ? 'var(--gold)' : (bezoek ? 'var(--green)' : 'var(--border)')}`,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all 0.2s',
                padding: 4,
              }}>
                {isPromoVakje ? (
                  <>
                    <img src={kaartPromo.logoSrc} alt={kaartPromo.naam} style={{ width: '80%', height: 'auto', borderRadius: 4 }} />
                    <span style={{ fontSize: 8, color: '#7a611a', marginTop: 3, fontFamily: 'Montserrat', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                      {kaartPromo.vakjeLabel}
                    </span>
                  </>
                ) : bezoek ? (
                  <>
                    <img src="/Every_wit.svg" alt="" style={{ width: '72%', height: 'auto', opacity: 0.92 }} />
                    <span style={{ fontSize: 10, color: 'rgba(255,255,255,0.9)', marginTop: 3, fontFamily: 'Montserrat', fontWeight: 700, letterSpacing: '0.03em' }}>
                      {(() => {
                        const d = new Date(bezoek.bezocht_op)
                        return `${d.getDate()} ${MAANDEN[d.getMonth()]}`
                      })()}
                    </span>
                  </>
                ) : (
                  <span style={{ fontSize: 11, color: 'var(--border)', fontFamily: 'Montserrat', fontWeight: 700 }}>
                    {i + 1}
                  </span>
                )}
              </div>
              )
            })}
          </div>
        )}
      </div>

      <div className="card">
        <p style={{ fontSize: 12, color: 'var(--muted)', lineHeight: 1.6 }}>
          Bezoeken worden bijgehouden door de balie. Elke keer dat je sport wordt de datum ingevuld op je fasekaart. Bij 20 bezoeken is een fase voltooid — de balie zet je dan door naar de volgende fase.
        </p>
        {lopendePromo && (
          <p style={{ fontSize: 12, color: 'var(--muted)', lineHeight: 1.6, marginTop: 10 }}>
            <strong style={{ color: 'var(--text)' }}>Actie {lopendePromo.kwartaalLabel}:</strong> {lopendePromo.promoTekst}
          </p>
        )}
      </div>
    </div>
  )
}
